// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".requirement-form__input[data-v-3a8f7d85]{display:inline-block;width:100px;margin-right:10px!important}.requirement-form__append[data-v-3a8f7d85]{font-size:1.2em}", ""]);
// Exports
module.exports = exports;
